//import common from '@/store/common/mutations';
import * as types from './mutation-types';

export default {
	//	...common,

	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.APPR_REASON_INFO]: (state, { key, value }) => {
		state.saveApprReason[key] = value;
	}
};
